"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _UIScrollContainer = _interopRequireDefault(require("UIComponents/scroll/UIScrollContainer"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIconButton = _interopRequireDefault(require("UIComponents/button/UIIconButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var PlanType = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/pricings/PlanType"));

var _useWindowDimensionsContext = require("ecosystem-marketplace-core/hooks/useWindowDimensionsContext");

var _usePrevious = require("../../../utils/hooks/usePrevious");

var _PricingPlanCard = _interopRequireDefault(require("./PricingPlanCard"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: 45%;\n  ", ": -40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ScrollButton = (0, _styledComponents.default)(_UIIconButton.default).withConfig({
  displayName: "Pricings__ScrollButton",
  componentId: "ocsa6s-0"
})(_templateObject(), function (props) {
  return props.direction;
});

var Pricings = function Pricings(_ref) {
  var onTrackInteraction = _ref.onTrackInteraction,
      pricings = _ref.pricings;
  var scrollRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      scrollX = _useState2[0],
      setScrollX = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isOverflow = _useState4[0],
      setIsOverflow = _useState4[1];

  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      windowWidth = _useWindowDimensionsC.width;

  var prevWindowWidth = (0, _usePrevious.usePrevious)(windowWidth);
  (0, _react.useEffect)(function () {
    if (scrollRef.current) {
      var el = scrollRef.current;

      var onScroll = function onScroll() {
        setScrollX(el.scrollLeft);
      };

      el.addEventListener('scroll', onScroll);
      return function () {
        el.removeEventListener('scroll', onScroll);
      };
    }

    return function () {};
  }, [scrollRef]);
  (0, _react.useEffect)(function () {
    if (scrollRef.current && windowWidth !== prevWindowWidth) {
      setIsOverflow(scrollRef.current.scrollWidth > scrollRef.current.offsetWidth);
    }
  }, [prevWindowWidth, windowWidth]);
  var isScrolledToBeginning = (0, _react.useMemo)(function () {
    return scrollX === 0;
  }, [scrollX]);
  var isScrolledToEnd = (0, _react.useMemo)(function () {
    return !!scrollRef.current && scrollX + scrollRef.current.offsetWidth >= scrollRef.current.scrollWidth;
  }, [scrollX]);

  var scrollToBeginning = function scrollToBeginning() {
    return scrollRef.current && scrollRef.current.scrollTo(0, 0);
  };

  var scrollToEnd = function scrollToEnd() {
    return scrollRef.current && scrollRef.current.scrollTo(scrollRef.current.scrollWidth - scrollRef.current.offsetWidth, 0);
  };

  var pricingCards = (0, _react.useMemo)(function () {
    return pricings.sortBy(function (plan, index) {
      return plan.get('planType') === PlanType.FREE ? -1 : index;
    }).map(function (plan, index) {
      return _react.default.createElement(_PricingPlanCard.default, {
        key: "plan-" + index,
        onTrackInteraction: onTrackInteraction,
        plan: plan,
        cardIndex: index
      });
    });
  }, [pricings, onTrackInteraction]);
  return _react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, _react.default.createElement(_UIScrollContainer.default, {
    gradientColor: _colors.GYPSUM,
    scrollElementRef: scrollRef
  }, _react.default.createElement(_UIFlex.default, {
    align: "stretch"
  }, pricingCards)), isOverflow && _react.default.createElement(_react.Fragment, null, _react.default.createElement(ScrollButton, {
    direction: "left",
    size: "sm",
    disabled: isScrolledToBeginning,
    onClick: scrollToBeginning
  }, _react.default.createElement(_UIIcon.default, {
    name: "left"
  })), _react.default.createElement(ScrollButton, {
    direction: "right",
    size: "sm",
    disabled: isScrolledToEnd,
    onClick: scrollToEnd
  }, _react.default.createElement(_UIIcon.default, {
    name: "right"
  }))));
};

Pricings.propTypes = {
  onTrackInteraction: _propTypes.default.func.isRequired,
  pricings: _reactImmutableProptypes.default.listOf(CustomPropTypes.pricingPlan).isRequired
};
var _default = Pricings;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/pricing/Pricings.js
// module id = 838
// module chunks = 209 210 211 212